import BannerStatic, { BannerType } from 'elem/compCommon/BannerStatic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('refurbished');
    const data: BannerType = {
        src: '/responsive/picture/refurbished/1.jpg',
        srcDesktop: '/responsive/picture/refurbished/1.jpg',
        srcPad: '/responsive/picture/refurbished/1_768.jpg',
        srcMobile: '/responsive/picture/refurbished/1_768.jpg',
        alt: t('secA_title'),
        title: t('secA_title'),
        desc: t('secA_desc'),
        link: '#refurbished-B',
        theme: 'black',
    };
    return (
        <div className={`refurbished-A ${css['refurbished-A']}`}>
            <BannerStatic {...data} />
        </div>
    );
}
